import 'css-chunksrc/client/pages/documentsPage/reportsPage/reportsList/styles.scss';export default {
  "reportsList": "_reportsList_1adqa_1"
};